<svg
  [attr.viewBox]="'0 0 ' + viewBoxWidth + ' ' + viewBoxHeight"
  preserveAspectRatio="xMidYMid meet"
  class="number-sets-venn__svg"
  (mouseleave)="onMouseLeave()"
>
  <!-- Transparent background to clear hover when mouse moves outside ellipses -->
  <rect
    x="0"
    y="0"
    [attr.width]="viewBoxWidth"
    [attr.height]="viewBoxHeight"
    fill="transparent"
    (mouseenter)="onMouseLeave()"
  />

  <!-- Ellipses: rendered outermost-first for correct z-order -->
  @for (s of reversedSetStates(); track s.config.id) {
    <ellipse
      class="number-sets-venn__ellipse"
      [attr.cx]="s.cx"
      [attr.cy]="s.cy"
      [attr.rx]="s.rx"
      [attr.ry]="s.ry"
      [style.fill]="s.fill"
      [style.stroke]="s.stroke"
      [style.stroke-width]="s.strokeWidth"
      (mouseenter)="onMouseEnter(s.index)"
    />
  }

  <!-- Labels and examples: rendered innermost-first (natural order) -->
  @for (s of setStates(); track s.config.id) {
    <!-- Set symbol label (KaTeX via foreignObject for consistent glyph weight) -->
    <foreignObject
      class="number-sets-venn__label-fo"
      [attr.x]="s.labelX - 30"
      [attr.y]="s.labelY - 16"
      width="60"
      height="32"
    >
      <div class="number-sets-venn__label" [style.color]="s.labelColor" [innerHTML]="s.labelHtml"></div>
    </foreignObject>

    <!-- Examples (via foreignObject for KaTeX rendering) -->
    @if (s.showExamples) {
      <foreignObject
        class="number-sets-venn__examples-fo"
        [attr.x]="s.examplesX - 70"
        [attr.y]="s.examplesY - 10"
        width="140"
        height="30"
      >
        <div class="number-sets-venn__examples" [style.color]="s.labelColor" [innerHTML]="s.examplesHtml"></div>
      </foreignObject>
    }
  }
</svg>
